import {
  EventStatusId,
  RugbyUnionEventStatusId,
} from '@collector/sportsapi-client-legacy'

export const pitchOverlaySupportedStatuses: EventStatusId[] = [
  RugbyUnionEventStatusId.FinishedRegularTime,
  RugbyUnionEventStatusId.FinishedAfterExtratime,
  RugbyUnionEventStatusId.FinishedAfterPenalties,
  RugbyUnionEventStatusId.FinishedAwardedWin,
  RugbyUnionEventStatusId.Abandoned,
  RugbyUnionEventStatusId.Postponed,
  RugbyUnionEventStatusId.Cancelled,
]
